import React from 'react'

function Feature(props) {
  return (
		<div className="features">
			<p>
				<strong>{props.text2}</strong>
				<span className={`${props.color}`}>{props.feature}</span>
			</p>
			<p>
				<strong>{props.text1}</strong>
				<span className={`${props.color}`}>{props.price}</span>
			</p>
		</div>
  );
}

export default Feature